namespace RedBullMOBILE360.AutomaticReports {
    export namespace MonitorAlertService {
        export const baseUrl = 'AutomaticReports/MonitorAlert';

        export declare function Create(request: Serenity.SaveRequest<MonitorAlertRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<MonitorAlertRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<MonitorAlertRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MonitorAlertRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AutomaticReports/MonitorAlert/Create",
            Update = "AutomaticReports/MonitorAlert/Update",
            Delete = "AutomaticReports/MonitorAlert/Delete",
            Retrieve = "AutomaticReports/MonitorAlert/Retrieve",
            List = "AutomaticReports/MonitorAlert/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>MonitorAlertService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
